/**
 * Money as the plans and the packs say it. Stripe's amounts are in the
 * currency's smallest unit: cents for dollars, yen for yen. Pure.
 */

/**
 * How many digits a currency's smallest unit has: 2 for dollars, 0 for
 * yen and won, 3 for dinars. Stripe's amounts are in that unit.
 */
function minorDigits(currency: string): number {
    try {
        return (
            new Intl.NumberFormat("en-US", { style: "currency", currency }).resolvedOptions()
                .maximumFractionDigits ?? 2
        );
    } catch {
        return 2;
    }
}

/** A sum in the smallest unit as a price: "$20", or "$16.67" when it has cents. */
export function formatPrice(cents: number, currency: string): string {
    const code = currency.toUpperCase();
    const digits = minorDigits(code);
    const unit = 10 ** digits;
    const smallest = Math.round(cents);
    const whole = smallest % unit === 0;
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: code,
            minimumFractionDigits: whole ? 0 : digits,
            maximumFractionDigits: whole ? 0 : digits,
        }).format(smallest / unit);
    } catch {
        return `${(smallest / unit).toFixed(whole ? 0 : digits)} ${code}`;
    }
}

/** A price a tailor, always with its cents: "$0.80". */
export function perTailor(cents: number, currency: string): string {
    const code = currency.toUpperCase();
    const digits = minorDigits(code);
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: code,
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        }).format(cents / 10 ** digits);
    } catch {
        return `${(cents / 10 ** digits).toFixed(digits)} ${code}`;
    }
}
